import React from 'react';
import { Card, CardContent } from '../../ui/card';

/**
 * Reusable stat tile used by Ledger + Customers tabs.
 * Accent controls the value color ('white' | 'green' | 'red').
 */
const StatTile = ({ label, value, accent = 'white', sub, testid }) => (
  <Card className="bg-slate-900 border-slate-800" data-testid={testid}>
    <CardContent className="p-4">
      <div className="text-xs uppercase tracking-wide text-gray-400">{label}</div>
      <div className={`text-2xl font-bold mt-1 tabular-nums ${
        accent === 'green' ? 'text-green-400' : accent === 'red' ? 'text-red-400' : 'text-white'
      }`}>{value}</div>
      {sub && <div className="text-[11px] text-gray-500 mt-1">{sub}</div>}
    </CardContent>
  </Card>
);

export default StatTile;
